import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef, type ReactElement, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Spinner } from '@/components/ui/Spinner';

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props): ReactElement | null {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();
  // §4-A7: el redirect debe dispararse UNA sola vez. Sin este guard, navigate('/login')
  // muta `location`, que re-dispara el effect → loop infinito de render (OOM en tests).
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !hasRedirected.current) {
      hasRedirected.current = true;
      const returnTo = location.pathname + location.search;
      void loginWithRedirect({ appState: { returnTo } });
      void navigate('/login', { replace: true });
    }
  }, [isLoading, isAuthenticated, location, loginWithRedirect, navigate]);

  if (isLoading) {
    return (
      <div role="status" aria-live="polite" className="flex h-screen items-center justify-center">
        <Spinner label="Cargando sesión" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
